import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=43b37e89&scoped=true"
var script = {}
import style0 from "./empty.vue?vue&type=style&index=0&id=43b37e89&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b37e89",
  null
  
)

export default component.exports